export const APP_CONSTANTS = {
  myAlertGridName: 'My Alerts',
  myDocumentsGridName: 'My Documents',
  myWorkGridName: 'My Work',
  myLinksGridName: 'My Links',
  versionControlGridname: 'versionControl',
  myNotificationRules: 'Notification Rules',
  lookupList: 'Lookup List'
};


export const CUSTOM_APP_DATA = {
  tiles: [
    {
      id: 1,
      count: '10',
      linksText: 'NOTIFICATION RULES',
      linkRoute: '/dashboard/no-header-canvas/my-notifications',
      firstLineText: 'My Alerts',
      secondLineText: 'New Alert: 1',
      isRightPanelVisible: true,
      isRightPanelOpenByDefault: true,
      route: 'dashboard/my-alerts',
      rightPanelRoute: 'dashboard/my-alerts/alert-details',
      isVisible: true
    },
    {
      id: 2,
      count: '5',
      linksText: 'MY WORK',
      linkRoute: 'My Work',
      firstLineText: 'My Tasks (routed to me)',
      secondLineText: 'New Task',
      isRightPanelVisible: false,
      isRightPanelOpenByDefault: false,
      route: 'dashboard/my-work',
      rightPanelRoute: '',
      isVisible: true

    },
    {
      id: 3,
      count: '6',
      linksText: 'SEARCH',
      linkRoute: 'My Recent Documents',
      firstLineText: 'My Recent Documents',
      secondLineText: '',
      isRightPanelVisible: false,
      isRightPanelOpenByDefault: false,
      route: 'dashboard/my-documents',
      rightPanelRoute: '',
      isVisible: true
    },
    {
      id: 4,
      count: '0',
      linksText: '',
      linkRoute: '',
      firstLineText: 'My Links',
      secondLineText: '',
      isRightPanelVisible: false,
      isRightPanelOpenByDefault: false,
      route: 'dashboard/my-links',
      rightPanelRoute: '',
      isVisible: true
    }
  ]
};
